export const tabContentStyles = {
    '.chakra-tabs__tab-panels > .chakra-tabs__tab-panel:nth-of-type(2) > .chakra-card, &.is-rules-tab .chakra-card':
        {
            bg: 'transparent',
            boxShadow: 'none',
            border: 'none',
            padding: 0,
            maxWidth: 'none',
        },
};

export const formContainerStyles = {
    noHorizontalDivider: {
        form: {
            '.chakra-stack .chakra-card': {
                w: 850,
                'hr.chakra-divider:last-of-type': {
                    display: 'none',
                },
            },
        },
    },
};

export const customSelectStyles = (customStyles, darkMode) => ({
    ...customStyles,
    container: (provided) => ({
        ...provided,
        ...customStyles.container(provided),
    }),
    control: (provided, state) => ({
        ...provided,
        ...customStyles.control(provided, state),
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    menuList: (provided, state) => ({
        ...provided,
        ...customStyles.menuList(provided, state),
        zIndex: 9999,
    }),
    option: (provided, state) => ({
        ...provided,
        ...customStyles.option(provided, state),
        color: darkMode ? 'white' : 'black',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: darkMode ? 'white' : 'black',
    }),
});
